import { render, staticRenderFns } from "./OrganisationSection.vue?vue&type=template&id=6c8e8966&scoped=true&"
import script from "./OrganisationSection.vue?vue&type=script&lang=js&"
export * from "./OrganisationSection.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationSection.vue?vue&type=style&index=0&id=6c8e8966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8e8966",
  null
  
)

export default component.exports